import { render } from "./AddFinancePayment.vue?vue&type=template&id=bc29e21c&scoped=true"
import script from "./AddFinancePayment.vue?vue&type=script&lang=js"
export * from "./AddFinancePayment.vue?vue&type=script&lang=js"

import "./AddFinancePayment.vue?vue&type=style&index=0&id=bc29e21c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc29e21c"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QIcon});
